<template>

    <div id="fb-post">
        <div class="headline ma-3 text-color bold">
<!--            Buff Mắt SV V1-->
        </div>
        <v-alert type="info">
            Comming soon.
        </v-alert>
        <div class="container-tabs" style="display: none">
            <v-tabs
                    :background-color="COLOR.BG_MAIN_COLOR"
            >
                <v-tab href="#create-process" active-class="text-color">Tạo tiến trình</v-tab>
                <v-tab href="#activity-log"  active-class="text-color">Nhật ký Order</v-tab>
                <v-tab-item value="create-process">
                    <FbFollowCreateProcess />
                </v-tab-item>
                <v-tab-item value="activity-log">
                    <FbFollowActivityLog />
                </v-tab-item>
            </v-tabs>
        </div>
    </div>
</template>

<script>
    import FbFollowCreateProcess from "~/components/fb-follow/FbFollowCreateProcess";
    import FbFollowActivityLog from "~/components/fb-follow/FbFollowActivityLog";
    import { COLOR } from "~/config/constant";
    export default {
        components: {
            FbFollowCreateProcess,
            FbFollowActivityLog
        },
        data() {
            return {
                COLOR: COLOR
            }
        },

    };
</script>
<style lang="scss">
    @import "../../scss/main";
    #fb-post {
        .v-tabs-slider-wrapper {
            color: $mainColor !important;
        }
        .text-color{
            color: $mainColor;
            font-weight: bold;
        }
    }
</style>
